import { BaseStepPropsV2 } from '../../common/v2/BaseStepV2.types';

export interface PickAProgramProps extends BaseStepPropsV2 {
  label?: string;
  useAbsoluteHeaderNavigation?: boolean;
}

export const DEFAULT_PLAN_KEY = 'a';
